import { render, staticRenderFns } from "./ContractUpgrade.vue?vue&type=template&id=b84a2b02"
import script from "./ContractUpgrade.vue?vue&type=script&lang=js"
export * from "./ContractUpgrade.vue?vue&type=script&lang=js"
import style0 from "./ContractUpgrade.vue?vue&type=style&index=0&id=b84a2b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports